import type {OrganizationEconomy} from 'organization/models/Organization'

export type PublicEconomySnapshot = OrganizationEconomy

export async function fetchPublicEconomy(): Promise<PublicEconomySnapshot> {
  const base = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '') ?? ''
  const res = await fetch(`${base}/api/platform/economy`)
  if (!res.ok) {
    throw new Error(`economy ${res.status}`)
  }
  return (await res.json()) as PublicEconomySnapshot
}
